import { inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { CanActivateFn, Router } from "@angular/router";
import { filter, map, take } from "rxjs";
import { TeamMemberRoleEnum } from "../enum/team-member-role.enum";
import { UserService } from "../services/user.service";

export interface RoleGuardData {
  roles: TeamMemberRoleEnum[];
}

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const data = route.data as RoleGuardData;

  return toObservable(userService.initCompleted).pipe(
    filter((completed) => completed === true),
    take(1),
    map(() => {
      const user = userService.currentUser();
      const requiredRoles = data?.roles ?? [];
      if (requiredRoles.length === 0) {
        return true;
      }

      const userRoles = user?.roles?.map((role) => role.name) ?? [];
      const hasRequiredRole = requiredRoles.some((role) =>
        userRoles.includes(role),
      );

      if (hasRequiredRole) {
        return true;
      }
      const hasPMRole = userRoles.includes(TeamMemberRoleEnum.PROJECT_MANAGER);
      const hasAccountantRole = userRoles.includes(
        TeamMemberRoleEnum.ACCOUNTANT,
      );
      const hasAdminRole = userRoles.includes(TeamMemberRoleEnum.ADMIN);
      if (hasAdminRole || hasPMRole) {
        return router.parseUrl("project-management/overview");
      } else if (hasAccountantRole) {
        return router.parseUrl("accounting/overview");
      } else {
        return router.parseUrl("unauthorized");
      }
    }),
  );
};
